/* Page Échantillons — messages clairs à l'ajout au panier (15/09/2026).
   Remplace le clic d'origine de #hg-ech-add (sections/hg-echantillons.liquid) :
   - surface manquante : message écrit sous le champ ;
   - ajout refusé par Shopify (ex. échantillon épuisé) : raison affichée dans la barre,
     au lieu d'une redirection vers un panier vide ;
   - 10 échantillons maximum par commande, en comptant ceux déjà dans le panier. */
(function () {
  var MAX = 10;
  var PHONE = '06 09 09 60 79';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Échantillons déjà dans le panier : variantes présentes et quantité totale.
  function samplesInCart(cart) {
    var ids = {};
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (item.product_type === 'Échantillon') {
        ids[item.variant_id] = true;
        total += item.quantity;
      }
    });
    return { ids: ids, total: total };
  }

  ready(function () {
    var addBtn = document.getElementById('hg-ech-add');
    if (!addBtn) return;
    var surfaceInput = document.getElementById('hg-ech-surface');
    var LABEL = addBtn.textContent;

    function showMessage(id, anchor, inBar) {
      var el = document.getElementById(id);
      if (!el) {
        el = document.createElement('div');
        el.id = id;
        el.setAttribute('role', 'alert');
        el.style.cssText = 'color:#c0392b;font-size:14px;font-weight:600;line-height:1.4;margin-top:6px;' +
          (inBar ? 'flex-basis:100%;width:100%;text-align:center;background:#fdf2f1;border-radius:8px;padding:8px 10px;' : '');
        anchor.insertAdjacentElement('afterend', el);
      }
      return el;
    }

    function clearMessage(id) {
      var el = document.getElementById(id);
      if (el) el.remove();
    }

    function resetButton(btn) {
      btn.disabled = false;
      btn.textContent = LABEL;
    }

    // Rappel sous le compteur quand le panier contient déjà des échantillons.
    var countEl = document.getElementById('hg-ech-count');
    if (countEl) {
      getCart().then(function (cart) {
        var inCart = samplesInCart(cart);
        if (!inCart.total) return;
        var note = document.createElement('p');
        note.style.cssText = 'margin:-8px 0 16px;font-size:13px;font-weight:600;color:' +
          (inCart.total >= MAX ? '#c0392b' : 'var(--hg-navy,#031b34)') + ';';
        // Le message doit dire OÙ sont les échantillons : sinon « maximum atteint » s'affiche
        // à côté de « 0 sélectionné » et le visiteur ne comprend pas.
        note.textContent = inCart.total >= MAX
          ? 'Votre panier contient déjà ' + inCart.total + ' échantillons : c\'est le maximum par commande. '
          : 'Vous avez déjà ' + inCart.total + ' échantillon' + (inCart.total > 1 ? 's' : '') +
            ' dans votre panier : ' + MAX + ' maximum par commande. ';
        var lien = document.createElement('a');
        lien.href = '/cart';
        lien.textContent = 'Voir mon panier →';
        lien.style.cssText = 'color:inherit;text-decoration:underline;white-space:nowrap;';
        note.appendChild(lien);
        (countEl.closest('.hg-ech__controls') || countEl).insertAdjacentElement('afterend', note);
      }).catch(function () {});
    }

    // Le bandeau cookies de Shopify (z-index 2 000 000) recouvre la barre « Ajouter au panier »,
    // fixée en bas de l'écran (z-index 9 999). Sur téléphone, le bouton devient injoignable.
    // Tant que le bandeau est là, on remonte la barre juste au-dessus.
    var bar = document.getElementById('hg-ech-bar');
    function placeBar() {
      if (!bar) return;
      bar.style.bottom = '';
      var banner = document.querySelector('#shopify-pc__banner');
      if (!banner) return;
      // Attention : offsetParent vaut null pour un élément en position fixed, comme ce bandeau.
      var st = window.getComputedStyle(banner);
      if (st.display === 'none' || st.visibility === 'hidden' || st.opacity === '0') return;
      var b = banner.getBoundingClientRect();
      // Le bandeau est collé en bas de l'écran : la barre passe juste au-dessus.
      if (b.height && b.bottom >= window.innerHeight - 4 && b.top > 0) {
        bar.style.bottom = Math.max(0, Math.round(window.innerHeight - b.top)) + 'px';
      }
    }
    function placeBarSoon() { setTimeout(placeBar, 400); }
    placeBar();
    window.addEventListener('resize', placeBarSoon);
    document.addEventListener('click', placeBarSoon, true);
    document.querySelectorAll('.hg-ech-cb').forEach(function (cb) {
      cb.addEventListener('change', placeBarSoon);
    });
    if (window.MutationObserver) {
      new MutationObserver(placeBarSoon).observe(document.body, { childList: true });
    }

    if (surfaceInput) {
      surfaceInput.addEventListener('input', function () { clearMessage('hg-ech-surface-msg'); });
    }
    document.querySelectorAll('.hg-ech-cb').forEach(function (cb) {
      cb.addEventListener('change', function () { clearMessage('hg-ech-add-msg'); });
    });

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('#hg-ech-add') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (btn.disabled) return;
      clearMessage('hg-ech-add-msg');

      var surface = surfaceInput ? surfaceInput.value.trim() : '';
      if (!surface || parseFloat(surface) <= 0) {
        // Le bouton est dans la barre fixe, en bas : le message doit s'y afficher aussi,
        // sinon le client ne voit rien et croit que le bouton est cassé.
        showMessage('hg-ech-add-msg', btn, true).textContent =
          'Indiquez d’abord la surface approximative de votre projet, en m², plus haut sur la page.';
        if (surfaceInput) {
          surfaceInput.classList.add('hg-ech__surface-input--error');
          showMessage('hg-ech-surface-msg', surfaceInput, false).textContent =
            'Indiquez la surface approximative de votre projet (en m²) pour ajouter les échantillons.';
          surfaceInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          surfaceInput.focus();
        }
        return;
      }

      var selected = [];
      document.querySelectorAll('.hg-ech-cb').forEach(function (cb) {
        if (cb.checked) selected.push(parseInt(cb.value, 10));
      });
      if (!selected.length) return;

      btn.disabled = true;
      btn.textContent = 'Ajout en cours…';
      getCart()
        .then(function (cart) {
          var inCart = samplesInCart(cart);
          var fresh = selected.filter(function (id) { return !inCart.ids[id]; });
          if (!fresh.length) {
            window.location = '/cart';
            return;
          }
          var room = MAX - inCart.total;
          if (fresh.length > room) {
            resetButton(btn);
            showMessage('hg-ech-add-msg', btn, true).textContent = room > 0
              ? MAX + ' échantillons maximum par commande. Vous en avez déjà ' + inCart.total +
                ' dans votre panier : décochez-en ' + (fresh.length - room) + '.'
              : 'Vous avez atteint le maximum de ' + MAX + ' échantillons par commande.';
            return;
          }
          var items = fresh.map(function (id) {
            return { id: id, quantity: 1, properties: { 'Surface approximative': surface + ' m²' } };
          });
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) {
              return r.json()
                .catch(function () { return {}; })
                .then(function (data) { return { ok: r.ok, data: data }; });
            })
            .then(function (res) {
              if (res.ok) {
                window.location = '/cart';
                return;
              }
              resetButton(btn);
              var reason = res.data && (res.data.description || res.data.message);
              showMessage('hg-ech-add-msg', btn, true).textContent = reason
                ? reason + ' Décochez cet échantillon ou contactez-nous au ' + PHONE + '.'
                : 'Ces échantillons n’ont pas pu être ajoutés. Réessayez ou contactez-nous au ' + PHONE + '.';
            });
        })
        .catch(function () {
          resetButton(btn);
          showMessage('hg-ech-add-msg', btn, true).textContent =
            'Problème de connexion : réessayez dans un instant ou appelez-nous au ' + PHONE + '.';
        });
    }, true);
  });
})();
